module.exports = __webpack_public_path__ + "static/assets/e0b1aa48d7e621424124e67d55cafee3.png";